(function () {
  const loader = document.currentScript;
  const subscriberId = loader?.dataset.okendoUserId;
  const requests = new Map();
  const countFormat = new Intl.NumberFormat('en-US');
  const ratingFormat = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  const linkFormats = {
    'sip-review-count': { kind: 'count' },
    'sip-five-star-review-count': { kind: 'five-star-count' },
    'sip-review-rating-average': { kind: 'rating', prefix: 'an average rating of ', suffix: ' stars' },
    'sip-review-rating-stars': { kind: 'rating', suffix: '-star average rating' },
  };
  const selector = '[data-sip-review-stat], a[href$="#sip-review-count"], a[href$="#sip-five-star-review-count"], a[href$="#sip-review-rating-average"], a[href$="#sip-review-rating-stars"]';

  function count(value) {
    return typeof value === 'number' && Number.isSafeInteger(value) && value >= 0
      ? value
      : null;
  }

  function getStats(id) {
    if (!id) return Promise.resolve(null);
    if (!requests.has(id)) {
      requests.set(id, (async function () {
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 5000);
        try {
          const response = await fetch(
            `https://api.okendo.io/v1/stores/${encodeURIComponent(id)}/review_aggregate`,
            { signal: controller.signal }
          );
          if (!response.ok) return null;
          const data = await response.json();
          const aggregate = data?.reviewAggregate;
          if (!aggregate) return null;
          const total = count(aggregate.reviewCount);
          const fiveStar = count(aggregate.reviewCountByLevel?.level5Count);
          const ratingTotal = aggregate.reviewRatingValuesTotal;
          const rating = total > 0 && typeof ratingTotal === 'number'
            ? ratingTotal / total
            : null;
          return {
            count: total,
            'five-star-count': fiveStar !== null && (total === null || fiveStar <= total)
              ? fiveStar
              : null,
            rating: Number.isFinite(rating) && rating >= 1 && rating <= 5 ? rating : null,
          };
        } catch (error) {
          return null;
        } finally {
          clearTimeout(timeout);
        }
      })());
    }
    return requests.get(id);
  }

  function refresh(root) {
    const elements = Array.from(root.querySelectorAll(selector));
    if (root.matches?.(selector)) elements.unshift(root);
    elements.forEach(async function (element) {
      const stats = await getStats(element.dataset.okendoUserId || subscriberId);
      const linkFormat = linkFormats[element.getAttribute?.('href')?.split('#')[1]];
      const kind = element.dataset.sipReviewStat || linkFormat?.kind;
      const value = stats?.[kind];
      if (value === null || value === undefined || !element.isConnected) return;
      const formatted = kind === 'rating' ? ratingFormat.format(value) : countFormat.format(value);
      const prefix = element.dataset.sipReviewPrefix ?? linkFormat?.prefix ?? '';
      const suffix = element.dataset.sipReviewSuffix ?? linkFormat?.suffix ?? '';
      element.textContent = `${prefix}${formatted}${suffix}`;
    });
  }

  window.SIPReviewStats = { refresh };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => refresh(document), { once: true });
  } else {
    refresh(document);
  }
  document.addEventListener('shopify:section:load', event => refresh(event.target));
})();
